import RulesModal from './RulesModal';

export {
  RulesModal,
}



// WEBPACK FOOTER //
// ./src/components/Game/components/GameInfo/components/index.js